import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useAuthStore } from '@features/auth/store/authStore';
import { notificationApi } from './notificationApi';

export function useNotifications(page = 1, unreadOnly = false) {
  const userId = useAuthStore((s) => s.user?.id);
  return useQuery({
    queryKey: ['notifications', userId, page, unreadOnly],
    queryFn: ({ signal }) => notificationApi.list(page, unreadOnly, signal),
    enabled: !!userId,
    staleTime: 5000,
    refetchInterval: 10000,
    refetchIntervalInBackground: true,
    retry: false,
  });
}
export function useNotificationPreferences() {
  const userId = useAuthStore((s) => s.user?.id);
  return useQuery({
    queryKey: ['notification-preferences', userId],
    queryFn: ({ signal }) => notificationApi.preferences(signal),
    enabled: !!userId,
    staleTime: 10000,
    refetchInterval: 30000,
    retry: false,
  });
}
export function useReadNotification() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, read = true }: { id?: string; read?: boolean }) =>
      notificationApi.read(id, read),
    onSuccess: async () => {
      await Promise.all([
        qc.invalidateQueries({ queryKey: ['notifications'] }),
        qc.invalidateQueries({ queryKey: ['notification-detail'] }),
      ]);
    },
  });
}
